import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import VueJwtDecode from 'vue-jwt-decode'

import { vuexTypes } from '@/vuex/types'
import { sessionStoragePlugin } from './plugins/session-storage'
import { AUTH_TYPE } from '@/js/const/auth-type.js'
import { UserRecord } from '@/js/records/entities/user.record'
import { MyRoleInfoRecord } from '@/js/records/entities/my-role-info.record'
import { api } from '@/api'

Vue.use(Vuex)

const INTERVAL_DELAY = 1000

export const rootModule = {
  actions: {
    [vuexTypes.LOG_OUT] ({ commit }) {
      commit(vuexTypes.CLEAR_STATE)
    },

    async [vuexTypes.LOAD_ACCOUNT] ({ commit, state }) {
      let accountId = state[vuexTypes.accountId]
      let { data } = await api.getWithSignature(`/users/${accountId}`)
      const account = new UserRecord(data)
      commit(vuexTypes.SET_ACCOUNT, account)
    },

    async [vuexTypes.LOAD_MY_ROLE_INFO] ({ commit, state }) {
      let { data } = await api.getWithSignature(`/profile/role-info`)
      const result = new MyRoleInfoRecord(data)
      commit(vuexTypes.SET_MY_ROLE_INFO, result)
    },

    async [vuexTypes.ENCODE_TOKEN] ({ commit }, { token }) {
      const jwtDecode = VueJwtDecode.decode(token.accessToken)

      commit(vuexTypes.SET_ACCOUNT_ADDRESS, jwtDecode.user_address)
      commit(vuexTypes.SET_ACCOUNT_ID, jwtDecode.user_id)
      commit(vuexTypes.SET_LOGOUT_TIME, jwtDecode.exp)

      commit(vuexTypes.SET_TOKEN_ATTRS, token)
      commit(vuexTypes.SET_TOKEN, token.accessToken)
      commit(vuexTypes.SET_AUTH_TOKEN, token.accessToken)
    },

    [vuexTypes.INIT_LOGOUT] ({ commit, getters }) {
      function timeCheck () {
        const logoutTime = moment.unix(getters[vuexTypes.logoutTime])
        if (getters[vuexTypes.isLoggedIn] &&
          moment().isSameOrAfter(logoutTime)) {
          commit(vuexTypes.CLEAR_STATE)
          location.reload()
        }
      }
      timeCheck()

      setInterval(timeCheck, INTERVAL_DELAY)
    },
  },

  mutations: {
    // These mutations are being subscribed by plugins
    [vuexTypes.POP_STATE] () { },
    [vuexTypes.CLEAR_STATE] () { },
    [vuexTypes.SET_TOKEN_ATTRS] (state, tokenAttrs) {
      state.tokenAttrs = tokenAttrs
    },
    [vuexTypes.SET_TOKEN] (state, token) {
      state.token = token
    },
    [vuexTypes.SET_AUTH_TOKEN] (state, token) {
      state.authToken = AUTH_TYPE + token
    },
    [vuexTypes.SET_ACCOUNT] (state, account) {
      state.account = account
    },
    [vuexTypes.SET_MY_ROLE_INFO] (state, data) {
      state.myRoleInfo = data
    },
    [vuexTypes.SET_ACCOUNT_ADDRESS] (state, accountAddress) {
      state.accountAddress = accountAddress
    },
    [vuexTypes.SET_ACCOUNT_ID] (state, accountId) {
      state.accountId = accountId
    },
    [vuexTypes.SET_LOGOUT_TIME] (state, logoutTime) {
      state.logoutTime = logoutTime
    },
  },
  getters: {
    [vuexTypes.isLoggedIn]: state => {
      return Boolean(state.token)
    },
    [vuexTypes.tokenAttrs]: state => {
      return state.tokenAttrs
    },
    [vuexTypes.token]: state => {
      return state.token
    },
    [vuexTypes.authToken]: state => {
      return state.authToken
    },
    [vuexTypes.account]: state => {
      return state.account
    },
    [vuexTypes.myRoleInfo]: state => {
      return state.myRoleInfo
    },
    [vuexTypes.accountAddress]: state => {
      return state.accountAddress
    },
    [vuexTypes.accountId]: state => {
      return state.accountId
    },
    [vuexTypes.isAdminAccount]: (_, getters) => {
      const role = getters[vuexTypes.account].role
      const isAdmin = role && role.match(/admin/i)
      return isAdmin
    },
    [vuexTypes.logoutTime]: state => {
      return state.logoutTime
    },
  },
  state: {
    tokenAttrs: {},
    token: '',
    authToken: '',
    account: {},
    myRoleInfo: {},
    accountAddress: '',
    accountId: '',
    logoutTime: '',
  },
}

let store
function buildStore () {
  store = new Vuex.Store({
    ...rootModule,
    modules: { },
    plugins: [sessionStoragePlugin],
  })
  store.commit(vuexTypes.POP_STATE)

  return store
}
buildStore()

export { store, buildStore }
export { vuexTypes } from './types'
